import StockFiltrationSettingsStore from "../../Stores/StockFiltrationSettingsStore";
import {Dropdown, Grid, List} from "semantic-ui-react";
import {InformationPanelItem} from "../Dashboard/InformationPanelItem";
import storesLookupStore from "../../Stores/StoresLookupStore";
import FieldWithCheckbox from "../Shared/FieldWithCheckbox";
import React from "react";
import {observer} from "mobx-react-lite";
import stockFiltrationMethodsLookupStore from "../../Stores/StockFiltrationMethodsLookupStore";
import FieldName from "../Shared/FieldName";
import FieldValue from "../Shared/FieldValue";

function StockFiltration(props: { settingStore: StockFiltrationSettingsStore }) {
    const {settingStore} = props;
    return (
        <>
            <Grid.Row>
                <FieldName width={4} name={'Способ расчета остатков'}/>
                <FieldValue width={6}>
                    <Dropdown fluid
                              value={settingStore.filtrationMethod}
                              selection
                              onChange={(_, e) => settingStore.setFiltrationMethod(e.value as string)}
                              options={stockFiltrationMethodsLookupStore.methods.map(x => {
                                  return {
                                      key: x.id,
                                      value: x.id,
                                      text: x.name,
                                      content:(
                                          <>
                                              <div>{x.name}</div>
                                              <div style={{
                                                  margin: '5px',
                                                  color: 'gray',
                                                  fontSize: 'small',
                                                  fontWeight: 400
                                              }}>{x.description}</div>
                                          </>
                                      )
                                  }
                              })}
                    />
                </FieldValue>
                <Grid.Column width={6}>
                    <InformationPanelItem header={'Склады'} shadows={false}>
                        <List>
                            {storesLookupStore.stores.map(store => {
                                    const avitoAccountStore = settingStore.getOrCreateStore(store.id);
                                    return <List.Item key={store.id}>
                                        <FieldWithCheckbox
                                            name={store.name}
                                            value={avitoAccountStore.isActive}
                                            onChange={value => avitoAccountStore.changeActive(value)}
                                        />
                                    </List.Item>
                                }
                            )}
                        </List>
                    </InformationPanelItem>
                </Grid.Column>
            </Grid.Row>
        </>
    )
}

export default observer(StockFiltration);